if($('#newsletter-modal').length > 0 ){
    if((Cookies.get('florrie-newsletter-modal')) !== 'shown' && top.location.pathname !== '/pages/privacy-policy') {
        setTimeout(function(){
            $('#newsletter-modal').fadeIn();
        },7000); 
    }
    $('.nm-close, .nm-bg').on('click',function(e){
        e.preventDefault();
        Cookies.set('florrie-newsletter-modal', 'shown', { expires: 3, path: '/' });
        $('#newsletter-modal').fadeOut();
    })
}


$('.newsletter-modal-trigger').on('click',function(e){
    e.preventDefault();
    // $('.rc-modal-window').fadeIn();
    $('#newsletter-modal').fadeIn();
});



function handlePartnerLogosSlider() {
    var $grid = $('.partner-logos-grid');
    if ($grid.length > 0) {
        var isMobile = window.innerWidth < 767;
        if (isMobile) {
            if (!$grid.hasClass('slick-initialized')) {
                $grid.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: false,
                    infinite: true,
                    variableWidth: true,
                    centerMode: true,
                    centerPadding: '100px',
                    autoplay: true,
                    autoplaySpeed: 0,
                    speed: 5000, // duration in ms for a full scroll (adjust as needed)
                    cssEase: 'linear',
                    pauseOnHover: false,
                    pauseOnFocus: false,
                });
            }
        } else if ($grid.hasClass('slick-initialized')) {
            $grid.slick('unslick');
        }
    }
}

// Run on document ready and window resize
$(document).ready(handlePartnerLogosSlider);
$(window).on('resize', function() {
    handlePartnerLogosSlider();
});

// function StickyItem(){
 
//         $(window).scroll(function() {
//             const mediaQuery = window.matchMedia('(min-width: 1024px)');
//             if (mediaQuery.matches) {
//             $(".bts__sticky-item").each(function(e) {
//                 var t, i = $(this).offset().top - 200;
//                 $(window).scrollTop() >= i ? (t = $(this).attr("data-target"), $(this).removeClass("opacity-0"), $(this).css("opacity", "1")) : (t = $(this).attr("data-target"), $(this).addClass("opacity-0"), $(this).css("opacity", ".2"))
//             });
//         }
//         });
    
//  }



// StickyItem();


// $(window).resize(function(){
//     StickyItem();
//   });

